import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { Icon } from '@/design-system'
import { unreadNotificationsCount } from '@/services/api/notifications'
import './avisos.css'

/**
 * La campanita: lleva a tus avisos y dice cuántos no has visto. Se vuelve a
 * mirar al volver a la app y cada minuto, que es lo que tarda en importar.
 * (§0080)
 */
export function NotificationBell() {
  const unread = useQuery({
    queryKey: ['notifications-unread'],
    queryFn: unreadNotificationsCount,
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
  const n = unread.data ?? 0

  return (
    <Link
      to="/avisos"
      className="icon-btn bell"
      aria-label={n > 0 ? 'Avisos: ' + n + ' sin leer' : 'Avisos'}
    >
      <Icon name="bell" size={21} />
      {n > 0 && <span className="bell__count">{n > 9 ? '9+' : n}</span>}
    </Link>
  )
}
